import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment-timezone';

const TimezoneSelector = ({ label, value, onChange }) => {
    const timezoneList = moment.tz.names();

    return (
        <Autocomplete
            id="timezone-selector"
            options={timezoneList}
            value={value}
            getOptionLabel={option => option}
            onChange={(e, value) => {
                // simulate syntatic event for TextField
                onChange({
                    target: { value }
                });
            }}
            renderInput={params => <TextField {...params} label={label}/>}
        />
    );
};

export default TimezoneSelector;
